import './ValueProposition.scss';
import ValuePropositionDivider from "./../../../ui/illustrations/value-proposition-divider";

const ValueProposition = () => {
  const content = {
    title: 'Potenciar Pequenas e Médias Empresas para Crescer',
    subtitle: 'Na Plover, simplificamos a sua jornada digital.',
    description:
      'O seu negócio merece as melhores ferramentas para crescer de forma ágil e eficaz. A nossa missão? Potenciar a sua produtividade e oferecer uma experiência inesquecível ao cliente. Estamos aqui para transformar desafios em soluções digitais inovadoras.',
  };

  return (
    <section className="vp section">
      <div className="wrapper wrapper--small centered">
        <h2 className="wrapper__title">{content.title}</h2>
        <h3 className="wrapper__subtitle h4">{content.subtitle}</h3>
        <p className="wrapper__description">{content.description}</p>
      </div>
      <ValuePropositionDivider className="vp__divider" />
    </section>
  );
};

export default ValueProposition;